import { jsx as o, jsxs as n, Fragment as g } from "react/jsx-runtime";
import { c as a, $ as x } from "../../vendor-D9Nsxj9p.js";
import { forwardRef as b } from "react";
import { omit as h } from "../../utils/omit/index.js";
import { BaseButton as K } from "../BaseButton/index.js";
import { Icon as c } from "../Icon/index.js";
import '../../assets/index4.css';const _ = "ooKxga_button", W = "ooKxga_fullWidth", $ = "ooKxga_md", B = "ooKxga_progress", N = "ooKxga_sm", s = {
  "bounce-center": "ooKxga_bounce-center",
  button: _,
  fullWidth: W,
  md: $,
  progress: B,
  sm: N
}, k = b(
  ({ size: t = "md", fullWidth: m = !1, label: l, startIcon: r, endIcon: e, ...u }, i) => {
    const f = {
      [s.button]: !0,
      [s[t]]: !0,
      [s.fullWidth]: m
    }, p = {
      [s.progress]: !0
    };
    return /* @__PURE__ */ o(K, { ...h(u, ["className", "style"]), className: a(f), ref: i, children: ({ isPending: d }) => d ? /* @__PURE__ */ n(x, { isIndeterminate: !0, className: a(p), children: [
      /* @__PURE__ */ o("span", {}),
      /* @__PURE__ */ o("span", {}),
      /* @__PURE__ */ o("span", {})
    ] }) : /* @__PURE__ */ n(g, { children: [
      r && /* @__PURE__ */ o(c, { icon: r, size: t }),
      l,
      e && /* @__PURE__ */ o(c, { icon: e, size: t })
    ] }) });
  }
);
export {
  k as Button
};
//# sourceMappingURL=index.js.map
